import cookies from 'js-cookie';
import { MdMessageBox as MessageBox } from 'mdesign3';
import router from '../router/index';
import { LogoutApi, getRoleGroup } from '../api/userApi';
import store from '../store/index';
import config from '@/config/user.env';
import { USER_INFO, CUR_ROLE, ROLE_LIST, CUR_TENANT } from '@/config/const';
import { clearAllPrefetch } from '@/utils/roleResourcesCache';
import { genrateModRouterMap } from './route.module';
import microApp from '@micro-zoe/micro-app';
import bigDataLog from '@/utils/bigLogData';
import { getChildModuleNameByPath } from '@/hooks/useMenuClick';
import { getCurrentRoleName } from '@/utils/bigLogData/trackHelper';

/**
 * @description 退出登录，手动退出，先调用4A登出，再调用4A登录；如自动登出，则直接跳转到4A登录
 * flag: true-手动登出；false: 比如401情况强制退出
 */
export const logout = async (flag = false) => {
  if (!flag) {
    await LogoutApi();
  }
  removeStorage();
  // 通知所有子应用退出登录
  const apps = microApp.getAllApps();
  apps.forEach((appName) => {
    microApp.setData(appName, { type: 'logout' });
  });
  // microApp.setData('*', { type: 'logout' });
  // router.replace('/login');
  // window.location.reload();
  setTimeout(() => {
    // 延迟一下，让通知所有子应用退出登录执行一下
    window.location.replace(window.location.origin + window.location.pathname);
  }, 250);
};

export const removeStorage = () => {
  clearAllPrefetch();
  store.commit('updateAppList', []);
  store.dispatch('delAllViews');
  cookies.remove('OAM_ID', { domain: '.annto.com' });
  cookies.remove('apmUser');
  localStorage.removeItem(USER_INFO);
  localStorage.removeItem('accessToken');
  localStorage.removeItem(CUR_ROLE);
  localStorage.removeItem(ROLE_LIST);
  localStorage.removeItem(CUR_TENANT);
  localStorage.removeItem('roleGroupCodes');
  localStorage.removeItem('_dx_captcha_vid');
  cookies.remove('_dx_captcha_vid');
  localStorage.removeItem('_dx_captcha_cid');
  cookies.remove('_dx_captcha_cid');
  localStorage.removeItem('_dx_uzZo5y');
  cookies.remove('_dx_uzZo5y');
  localStorage.removeItem('_dx_FMrPY6');
};

/**
 * @description 手动删除cookie
 * @param name
 */
export const deleteCookie = (name = '') => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
export function alertErrorAndLogout(msg: string) {
  MessageBox.alert(msg, '错误', {
    confirmButtonText: '确定',
    callback: () => {
      logout(true);
    },
  });
}

export function checkAndAlertError(data: { code: string | number; msg: string }) {
  const NO_LOGIN = 105;
  const ERROR_STATUS = 1;
  if (data && +data.code !== 0) {
    if (data && +data.code === NO_LOGIN) {
      alertErrorAndLogout(data.msg || '当前没有登录的用户');
    } else if (data && +data.code === ERROR_STATUS) {
      alertErrorAndLogout('当前票据已失效，请重新登录');
    } else {
      alertErrorAndLogout(data.msg || '接口返回异常');
    }
  }
}

// 判断前往对应的首页
export const checkGoHome = (to: any, next: any) => {
  const routerMap = genrateModRouterMap(store.getters.authority);
  if (to.path === '/index') {
    const extendAttrMap = flatMapDeep(store.getters.authority, 'subResources');
    const homeAuthority = extendAttrMap.find((item) => {
      return item.extendAttr1 && item.extendAttr1.indexOf('isIndex=true') > -1;
    });
    if (homeAuthority) {
      next(homeAuthority.frontUrl);
      return;
    }
    const homePath = routerMap.find((item: string) => {
      return item.indexOf('/index') > -1 && item.endsWith('/index');
    });
    if (homePath && homePath.split('/').filter((item: string) => item)[1] === 'index') {
      next(homePath);
      return;
    }
  }
  next();
};

/**
 * @description 校验是否有菜单权限
 */
function checkMenuAuthority(to) {
  const routerMap = genrateModRouterMap(store.getters.authority);
  // console.log(
  //   routerMap.filter((item) => {
  //     return item.indexOf('/microOtp') > -1;
  //   }),
  // );
  // const currentPath = window.location.hash.split('#')[1];
  const currentPath = to.path;
  return routerMap.length ? checkCurrentPath(to, routerMap, currentPath) : false;
}
/**
 * 获取子应用路由的 meta 信息
 */
function getMicroRouteMeta(to) {
  const microName = to.name;
  if (!microName || !microName.startsWith('micro')) return null;

  const microRoutes = store.state.microRoutes?.[microName];
  if (!microRoutes || !Array.isArray(microRoutes)) return null;

  // 获取子应用路由的实际路径（去掉 microName 前缀）
  const microPath = to.path.replace(`/${microName}`, '') || '/';

  // 匹配子应用路由
  const matchedRoute = microRoutes.find((r: any) => {
    const routePath = r.path || '';
    return routePath === microPath || routePath === to.path;
  });

  return matchedRoute?.meta || null;
}
function checkCurrentPath(to, routerMap, currentPath) {
  if (to.path === '/index') return true;
  if (to.path === '/401') return true;
  // 如果有 query 参数，检查子应用路由 meta 中的 authority 是否有值
  if (Object.keys(to.query).length) {
    const microName = to.name;
    // 如果是子应用路由，检查 meta.authority 是否有值
    if (microName && microName.startsWith('micro')) {
      let authorityArray: string[] = [];
      if (to.query.toMetaAuthority) { // 首次加载由子应用传递过来的authority
        let rawAuth = to.query.toMetaAuthority;
        // 【关键修复】处理 Query 参数可能是字符串的情况
        if (typeof rawAuth === 'string' && rawAuth.trim() !== '') {
          try {
            // 尝试解析 JSON 字符串 (如果子应用传递的是 JSON.stringify 后的结果)
            rawAuth = JSON.parse(rawAuth);
          } catch (e) {
            // 如果不是 JSON，可能是逗号分隔的字符串 "auth1,auth2"
            rawAuth = rawAuth.split(',');
          }
        }
        if (Array.isArray(rawAuth)) {
          authorityArray = rawAuth;
        }
      }else {
        const meta = getMicroRouteMeta(to);
        authorityArray = meta?.authority;
      }
      // 如果 meta.authority 有值，则不跳过校验，需要进行权限验证
      if (authorityArray && Array.isArray(authorityArray) && authorityArray.length > 0) {
        // return routerMap.includes(currentPath);
        // 检查UAP返回的资源列表有没有权限页面所需的关键url精确匹配或模糊匹配
        // 使用 some 替代 forEach，找到匹配项返回 true 并自动停止遍历
        const hasPermission = authorityArray.some((item: string) => {
            // 子应用路由item的实际路径（拼接 microName 前缀）
            let checkPath = item;
            if (!checkPath.startsWith('/' + microName)) {
              // 处理 item 可能带或不带前导斜杠的情况，确保拼接正确
              checkPath = '/' + microName + (item.startsWith('/') ? item : '/' + item);
            }
            // 授权的路由表中是否包含该路径
            // return routerMap.includes(microItemPath);// 精确匹配
            // 模糊匹配
            return routerMap.some((authPath: string) => 
              authPath.startsWith(checkPath) || checkPath.startsWith(authPath)
            );
        });
        return hasPermission;
      }
    }
    // 其他情况有 query 则跳过校验
    return true;
  }
  if (to.name === 'microOms' || to.name === 'microTms') {
    // 详情页直接跳过校验
    // 没有配置菜单页面，且路由跳转没有带参的，直接跳过校验
    if (
      [
        `/${to.name}/distribute/visual-map-layout`,
        `/${to.name}/index`,
        `/${to.name}/order-manage/order-change-detail`,
        `/${to.name}/dispatch-Manage/mapMaintain`,
      ].includes(to.path)
    )
      return true;
  }
  // 重定向页面直接跳过校验
  if (to.path.includes('/redirect')) return true;
  return routerMap.includes(currentPath);
}

/**
 * 无权限时，优先替换当前页签为 401，而不是新增页签
 */
function redirectTo401ByReplace(to: any, next: any) {
  const currentView = store.getters.visitedViews?.find((item: any) => item.path === to.path);
  if (currentView) {
    store.dispatch('delView', currentView);
  }
  next({
    path: '/401',
    query: { url: to.path },
    replace: true,
  });
}

// 加密解密
export class CryptoHelper {
  // 生成 AES 密钥
  static async generateKey() {
    return await crypto.subtle.generateKey(
      {
        name: 'AES-GCM',
        length: 256, // 256 位密钥
      },
      true, // 密钥是否可导出
      ['encrypt', 'decrypt'], // 密钥用途
    );
  }

  // 加密数据
  static async encrypt(data: any, key: string) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(data); // 编码字符串数据

    // const iv = crypto.getRandomValues(new Uint8Array(12)); // 生成随机 IV (初始化向量)
    const inputString = '136, 116, 195, 93, 239, 173, 34, 164, 222, 93, 71, 174';
    const byteArray = inputString.split(',').map((num) => parseInt(num.trim(), 10));
    const iv = new Uint8Array(byteArray);

    const encryptedData = await crypto.subtle.encrypt(
      {
        name: 'AES-GCM',
        iv, // 初始化向量
      },
      key, // 密钥
      encodedData, // 待加密数据
    );
    const encryptedDataBase64 = changeToBase64String(encryptedData); // 转换为 Base64 字符串
    return encryptedDataBase64; // 返回加密数据和 IV
  }

  // 解密数据
  static async decrypt(encryptedDataBase64: string, key: string) {
    const encryptedData = changeToArrayBuffer(encryptedDataBase64); // 转换为 ArrayBuffer
    const inputString = '136, 116, 195, 93, 239, 173, 34, 164, 222, 93, 71, 174';
    const byteArray = inputString.split(',').map((num) => parseInt(num.trim(), 10));
    const iv = new Uint8Array(byteArray);
    const decryptedData = await crypto.subtle.decrypt(
      {
        name: 'AES-GCM',
        iv, // 必须使用相同的 IV 来解密
      },
      key, // 用于解密的密钥
      encryptedData, // 待解密数据
    );

    const decoder = new TextDecoder();
    return decoder.decode(decryptedData); // 返回解密后的数据
  }

  // 哈希数据 (SHA-256)
  static async hashData(data) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(data);

    const hashBuffer = await crypto.subtle.digest('SHA-256', encodedData); // 计算 SHA-256 哈希值
    const hashArray = new Uint8Array(hashBuffer); // 转换为字节数组

    return Array.from(hashArray)
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join(''); // 返回哈希值的十六进制字符串
  }

  // 导出密钥
  static async exportKey(key) {
    return await crypto.subtle.exportKey('jwk', key); // 导出密钥为 JWK 格式
  }

  // 导入密钥
  static async importKey(jwkKey) {
    return await crypto.subtle.importKey(
      'jwk', // 导入 JWK 格式的密钥
      jwkKey,
      {
        name: 'AES-GCM',
        length: 256,
      },
      true, // 密钥是否可导出
      ['encrypt', 'decrypt'],
    );
  }
}
// 将 ArrayBuffer 转为 Base64 字符串
export const changeToBase64String = (arrayBuffer: ArrayBuffer) => {
  let binary = '';
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < uint8Array.length; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  return btoa(binary);
};

// 将 Base64 字符串转回 ArrayBuffer
export const changeToArrayBuffer = (base64String: string) => {
  const decodedBinary = atob(base64String);
  const newArrayBuffer = new ArrayBuffer(decodedBinary.length);
  const newUint8Array = new Uint8Array(newArrayBuffer);
  for (let i = 0; i < decodedBinary.length; i++) {
    newUint8Array[i] = decodedBinary.charCodeAt(i);
  }
  return newArrayBuffer; // 返回 ArrayBuffer
};

/**
 * @description vue实例前判断登录状态，初始登录信息
 */

// 白名单子应用不做菜单权限校验
const whitelistSubApp = ['microLsrm', 'microLsp', 'app-cci', 'bmsMicroApp, app-cop', 'ams', 'report'];

// 子系统映射
const systemMapping: Record<string, string> = {
  'tms': 'microTms',
  'oms': 'microOms',
  'el-data-report': 'microDataReport',
  'lsp': 'microLsp',
  'lsrm': 'microLsrm',
  'ntp': 'microNtp',
};
const getSystemKeyFromExtendAttr = (extendAttr1: string): string | null => {
  const attrStr = (extendAttr1 || '').trim();
  const params = new Set(
    attrStr ? attrStr.split('&').map((s: string) => s.trim()).filter(Boolean) : []
  );
  if (params.has('oms') || params.has('oms=true')) return 'oms';
  if (params.has('tms') || params.has('tms=true')) return 'tms';
  if (params.has('el-data-report')) return 'el-data-report';
  return null;
};

// 从根资源列表中查找匹配节点
// 匹配逻辑：取路径前两段作为模块前缀进行匹配
// 例如：/microOtp/order-manage/detail → 匹配 frontUrl 前两段同为 /microOtp/order-manage 的节点
// 原逻辑取路径前两段（含 micro 前缀）如 /microOtp/order-manage；
// processRoleResources 已将 authority 中 microOtp 替换为 microOms/microTms，
// 故改为跳过 micro 前缀后取第一段业务模块名（等价于原 slice(0,2) 去掉 micro 段）
// 例如：/microOtp/dispatch-Manage/detail → /dispatch-Manage，匹配 /microTms/dispatch-Manage/...
const findFromRootResources = (microPath: string): string | null => {
  const authority = store.getters.authority || [];
  const pathParts = microPath.split('/').filter(Boolean);
  if (pathParts.length < 2) return null;
  // 跳过 micro 前缀，取第一段业务模块名，等价于原 slice(0,2) 去掉 micro 段，例如/microOtp/dispatch-Manage/...  →  /dispatch-Manage
  const currentModulePrefix = '/' + pathParts.slice(1, 2).join('/');

  const traverse = (nodes: any[]): string | null => {
    for (const node of nodes) {
      if (node.frontUrl && typeof node.frontUrl === 'string') {
        const nodeParts = node.frontUrl.split('/').filter(Boolean);
        // 跳过 micro 前缀，取第一段业务模块名，等价于原 slice(0,2) 去掉 micro 段，例如/microTms/dispatch-Manage/...  →  /dispatch-Manage
        const nodeModulePrefix = '/' + nodeParts.slice(1, 2).join('/');
        if (nodeModulePrefix === currentModulePrefix) {
          const systemKey = getSystemKeyFromExtendAttr(node.extendAttr1);
          if (systemKey) return systemKey;
        }
      }
      if (node.subResources?.length) {
        const found = traverse(node.subResources);
        if (found) return found;
      }
    }
    return null;
  };
  return traverse(authority);
};
// microOtp 前缀路由：authority 匹配则重定向到子系统；未匹配则放行，由 microOtp 子应用 routerReplaceMethod 处理
const handleMicroOtpRedirect = (to: any, next: any): boolean => {
  if (!to.path.startsWith('/microOtp')) return false;
  const systemKey = findFromRootResources(to.path);
  if (systemKey && systemKey in systemMapping) {
    const targetSystem = systemMapping[systemKey];
    const newPath = to.path.replace(/^\/microOtp/, `/${targetSystem}`);
    next({ path: newPath, query: to.query });
    return true;
  }
  next();
  return true;
};

export async function checkLogin(router, whiteList, loginRequiredList = []) {
  router.beforeEach((to: any, from: any, next: any) => {
    const isLoginRequiredRoute = loginRequiredList && loginRequiredList.indexOf(to.path) !== -1;
    // PC 端重定向到微前端子应用
    if (to.path === '/h5/bulletin-board') {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'mobile', 'windows phone'];
      const isMobileUA = mobileKeywords.some((keyword) => userAgent.includes(keyword));
      if (!isMobileUA) {
        const systemPrefix = 'microDataReport';
        return next({
          path: `/${systemPrefix}/overdue-redemption-dashboard`,
        });
      }
    }
    if (whiteList && whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      const { userCode } = store.getters.user;
      const authority = store.getters.authority;
      const appList = store.getters.appList;
      if (userCode && appList.length) {
        if (isLoginRequiredRoute) {
          return next();
        }
        if (handleMicroOtpRedirect(to, next)) return;
        if (authority && authority.length) {
          pageMaintenanceNotice(to, next);
        } else {
          if (to.path === '/index') {
            next();
          } else {
            next('/index');
          }
        }
      } else {
        const userInfo = localStorage.getItem(USER_INFO);
        if (userInfo) {
          store
            .dispatch('initSystem')
            .then((res) => {
              if (res) {
                // 系统初始化成功后，记录用户访问次数（childModuleName 与 sendDetailMessage 一致）
                const path = to.path?.split('?')[0] || '';
                bigDataLog.sendMainMessage(getChildModuleNameByPath(path, getCurrentRoleName()));
              }
              if (isLoginRequiredRoute && res) {
                return next();
              }
              if (handleMicroOtpRedirect(to, next)) return;
              store.dispatch('delAllViews');
              if (!checkMenuAuthority(to)) {
                if (whitelistSubApp.includes(to.name)) {
                  next();
                } else {
                  // next(`/401?url=${to.path}`);
                  next('/');
                }
              } else if (res) {
                if (to.name !== 'login') {
                  pageMaintenanceNotice(to, next);
                } else {
                  next('/');
                }
              }
            })
            .catch(() => {
              logout(true);
            });
        } else {
          let redirectUrl = '';
          if (to.fullPath !== '/index') {
            redirectUrl = `?redirectUrl=${encodeURIComponent(to.fullPath)}`;
          }
          next(`/login${redirectUrl}`);
        }
      }
    }
  });
}

// 跳转到注册页面
export const toRegister = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    alert('移动端暂不支持,请移步pc端注册使用');
  } else {
    window.open(config.registerUrl + '?from=el&redirectUrl=' + encodeURIComponent(window.location.href), '_blank');
  }
};

// 跳转到找回忘记的密码页面
export const toFindPassword = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    alert('移动端暂不支持,请移步pc端注册使用');
  } else {
    window.open(config.findPasswordUrl + '?from=el&redirectUrl=' + encodeURIComponent(window.location.href), '_blank');
  }
};
// 跳转到工作台页面
export const toWorkbench = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    alert('移动端暂不支持,请移步pc端注册使用');
  } else {
    window.open(config.workbenchUrl + '?from=el&redirectUrl=' + encodeURIComponent(window.location.href), '_blank');
  }
};

// 扁平化数组 并记录父级
export const flatMapDeep = (array: Array<any>, key = 'children', parents: Array<any> = []) => {
  const result: Array<any> = []; // 用于存储扁平化结果
  array.forEach((item) => {
    // 将当前对象添加到结果数组，同时记录父级
    result.push({ ...item, parent: [...parents] });
    // 如果有children，递归处理
    if (Array.isArray(item[key]) && item[key].length > 0) {
      result.push(...flatMapDeep(item[key], key, [...parents, item])); // 递归调用并传入当前项作为父级
    }
  });
  return result;
};

// 递归修改数组里面的值
export const deepMap = (array: Array<any>, key = 'children', cb: (arg0: any) => void) => {
  array.forEach((item) => {
    cb(item);
    if (Array.isArray(item[key]) && item[key].length > 0) {
      deepMap(item[key], key, cb);
    }
  });
};

// 全局页面维护提示
export const pageMaintenanceNotice = async (to: any, next: any) => {
  const authority = store.getters.authority;
  const { fullPath } = to;
  const flatSearchMenu = flatMapDeep(authority || [], 'subResources').filter((item) => item.resourceType === 2);
  const maintenanceMenu = flatSearchMenu.find((item) => item.frontUrl === fullPath);
  const { resourceCode } = maintenanceMenu || {};
  const params = {
    pageNo: 1,
    pageSize: 100,
    dictCode: 'EL_PAGE_MESSAGE_POOL',
  };
  const res = await getRoleGroup(params);
  if (res.code === '0' && res.data && res.data?.list.length) {
    const list = res.data?.list;
    const pageMessage = list.find((item) => item.code === resourceCode);
    const name = pageMessage?.name || '';
    if (pageMessage && name) {
      const messageInfo = name.split('&');

      MessageBox.alert(messageInfo[1], '提示', {
        customClass: 'page-message-box',
        confirmButtonText: '立即跳转',
        buttonSize: 'default',
        type: 'warning',
        center: true,
      }).then(() => {
        window.open(messageInfo[2], '_blank');
        if (window.location.hash.includes(maintenanceMenu.frontUrl)) {
          const { origin, pathname } = window.location;
          window.location.href = origin + pathname;
        } else {
          next('/');
        }
      });
    } else {
      if (!checkMenuAuthority(to)) {
        if (whitelistSubApp.includes(to.name)) {
          next();
        } else {
          // next(`/401?url=${to.path}`); // 当前标签页无权限时，这样会新增页签为 401
          redirectTo401ByReplace(to, next); // 无权限时，优先替换当前页签为 401，而不是新增页签
        }
      } else {
        checkGoHome(to, next);
      }
    }
  } else {
    if (!checkMenuAuthority(to)) {
      if (whitelistSubApp.includes(to.name)) {
        next();
      } else {
        // next(`/401?url=${to.path}`); // 当前标签页无权限时，这样会新增页签为 401
        redirectTo401ByReplace(to, next); // 无权限时，优先替换当前页签为 401，而不是新增页签
      }
    } else {
      checkGoHome(to, next);
    }
  }
};

/**
 * @description 数组移动
 *
 * 将数组从当前下标迁移到目标下标下
 *
 * @param { Array } arr  目标数组
 * @param { number } index  当前下标
 * @param { number } targetIndex 目标下标
 * @returns { Array } 数组
 *
 * @typeParam { T } T 数组类型
 *
 * @example
 * ```javascript
 * import { arrMove } from '@annto/tools';
 *
 * arrMove([1, 2, 3], 0, 2); // 返回 [2, 3, 1]
 * ```
 */
export const arrMove = <T>(arr: T[] = [], index = 0, targetIndex = 0): T[] => {
  arr.splice(targetIndex, 0, arr.splice(index, 1)[0]);
  return arr;
};

/**
 * @description 翻译参数
 * - `defaultText` 默认文字
 */
type Translate = {
  defaultText: string;
};
/**
 * @description 翻译方法 $translate
 *
 * @param key 翻译的 key 值
 * @param params 参数对象
 * @param params.defaultText: 默认显示的文字
 * @returns
 *
 * @example
 *
 * ```javascript
 * import { $translate } from '@annto/tools';
 *
 * $translate('lang.E1202108162126', { defaultText: '区域' });
 * ```
 */
export const $translate = function (key: string, params: Translate) {
  if (params && params.defaultText) {
    return params.defaultText;
  } else {
    return key;
  }
};

/**
 * @deprecated 3.0 版本删除
 * @description 国际化混入 I18nMixins
 * 将  $translate 方法混入 Vue 的方法中。
 */
export const I18nMixins = {
  methods: {
    // 用于处理语言包不存在的时候 使用缺省值
    $translate(key: string, params: Translate) {
      // deprecatedWarn('i18nMixins', '3.0');
      return $translate(key, params);
    },
  },
};

import { lotsUIEventInstance } from './event';

interface IAlive {
  insertKeepAlivePage(name: string): void;
  removeKeepAlivePage(name: string): void;
}
class KeepAlive implements IAlive {
  private static instance: IAlive;
  private static notAlivePageNames: Set<string>;

  private constructor() {}

  public static getInstance() {
    if (!KeepAlive.instance) {
      KeepAlive.notAlivePageNames = new Set();
      KeepAlive.instance = new KeepAlive();
    }
    return KeepAlive.instance;
  }

  public insertKeepAlivePage(name: string) {
    // 注掉无用代码
    // typeof name === 'string' && KeepAlive.notAlivePageNames.delete(name);
    // lotsUIEventInstance.trigger('changeAlivePageNames', KeepAlive.notAlivePageNames);
  }

  public removeKeepAlivePage(name: string) {
    // 注掉无用代码
    // typeof name === 'string' && KeepAlive.notAlivePageNames.add(name);
    // lotsUIEventInstance.trigger('changeAlivePageNames', KeepAlive.notAlivePageNames);
  }
}
const keepAliveInstance = KeepAlive.getInstance();

export { IAlive, keepAliveInstance };
